export default "__VITE_ASSET__B32z1Rp___"